import React, { useEffect, useState } from 'react'
import { FaArrowLeft } from "react-icons/fa";
import { Box, Rating, Typography, useTheme, Skeleton } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { FlexBox, HeadingText, ValueText } from '../../../../Checkout/style';
import useGetClassDate from '../../../../../Infrastructure/CustomHooks/useGetClassDate';
import { classScheduleFormat } from '../../../../../Infrastructure/Utilities/classScheduleFormat';
import { classDetailsSx } from './styles';
import { useNavigate } from 'react-router-dom';
import { SHOW_RATINGS } from '../../../../../Infrastructure/Constants/ratingsState';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEducator } from '../../../../../Infrastructure/States/thunks/fetchEducatorThunk';
import { fetchCourse } from '../../../../../Infrastructure/States/thunks/fetchCourseThunk';
import { Loader } from '../../../../Common/Loader/loader';
import { resetEducatorData } from '../../../../../Infrastructure/States/educatorSlice';
import { resetCourseData } from '../../../../../Infrastructure/States/singleCourseSlice';
import { ErrorView } from '../../../../Common/ErrorComponents/errorView';
import UserVector from '../../../../../Assets/Images/vector.png'
import CourseVector from '../../../../../Assets/Images/courseVector.png'
import paths from '../../../../../Infrastructure/Router/paths';

export const ClassDetailPage = ({ classData, handleBackToList }) => {
    const theme = useTheme();
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [avatarLoaded, setAvatarLoaded] = useState(false);
    const [courseImageError, setCourseImageError] = useState(false);
    const [courseImageLoaded, setCourseImageLoaded] = useState(false);
    const educatorData = useSelector((state) => state.educator.data);
    const courseError = useSelector((state) => state.educator.error);
    const educatorError = useSelector((state) => state.singleCourse.error);
    const educatorLoading = useSelector((state) => state.educator.loading);
    const courseData = useSelector((state) => state.singleCourse.data);
    const courseLoading = useSelector((state) => state.singleCourse.loading);
    const { course_title, duration, first_class, last_class, cohort, times, course_id, educator_id } = classData;
    const classTimes = times
    const firstClass = useGetClassDate(first_class);
    const lastClass = useGetClassDate(last_class);
    const formatTimes = classScheduleFormat(classTimes)
    const courseImage = courseData?.courseDetails?.details?.course_image 
    useEffect(() => {
        if (educator_id) {
            dispatch(fetchEducator(educator_id))
        }
        if (course_id) {
            dispatch(fetchCourse(course_id))
        }
        // cleanup the state when component unmounts or ids change
        return () => {
            dispatch(resetEducatorData());
            dispatch(resetCourseData());
        };
    }, [dispatch, educator_id, course_id])

    if (educatorLoading || courseLoading) {
        return <Loader height='80vh'/>
    }
    return (
        <Box sx={classDetailsSx.pageWrapper}>
            <Box sx={classDetailsSx.backArrowBox}>
                <FaArrowLeft fontSize={18} onClick={handleBackToList} />
            </Box>
        {(courseError || educatorError) ? <Box sx={{py:20}}> <ErrorView onRetry={() => window.location.reload()} /> </Box>:
         (
            <Box sx={classDetailsSx.content}>
                <Typography sx={classDetailsSx.title} color="primary">
                    {course_title}
                </Typography>
                <Grid container sx={classDetailsSx.gridContainer}>
                    <Grid xs={12} md={5.5}>
                <Box
                    height={{ xs: "200px", sm: "170px" }}
                    width={{ xs: '100%', sm: '300px' }}
                    sx={classDetailsSx.courseImageBox}
                    onClick={() => navigate(paths.coursesPage.path + `/${courseData?.url}`)}
                >
                    {!courseImageLoaded && (
                        <Skeleton variant="rectangular" width="100%" height="100%" sx={classDetailsSx.skeletonAbsolute} />
                    )}
                    <img
                    src={courseImageError ? CourseVector : courseImage}
                    alt="not found"
                    onLoad={() => setCourseImageLoaded(true)}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = CourseVector;
                        setCourseImageError(true);
                        setCourseImageLoaded(true);
                    }}
                    style={{
                        display: courseImageLoaded ? 'block' : 'none',
                        height: '100%',
                        width: '100%',
                        objectFit: 'cover',
                        borderRadius: "30px",
                        aspectRatio: "16 / 9"
                                }}
                            />
                        </Box>
                        <Box
                            display={'flex'}
                            alignItems={'center'}
                            gap={3}
                            mt={2}
                            sx={classDetailsSx.educatorBox}
                            onClick={() => navigate(paths.educators.path + `/${educatorData?.educator?.url}`)}
                        >
                            <Box sx={classDetailsSx.avatarBox}>
                <Box sx={classDetailsSx.avatarBox}>
                    {!avatarLoaded && (
                        <Skeleton variant="circular" width="100%" height="100%" sx={classDetailsSx.skeletonAbsolute} />
                    )}
                    <img
                    src={educatorData?.educator?.profile?.avatar || UserVector}
                    alt="profile"
                    onLoad={() => setAvatarLoaded(true)}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = UserVector;
                        setAvatarLoaded(true);
                    }}
                    style={classDetailsSx.avatarImage}
                    />
</Box>

                    </Box>
                    <Box display={'flex'} flexDirection={"column"} alignItems={'center'}>
                    <Typography color="black" sx={classDetailsSx.educatorName}>
                        By {educatorData?.account?.first_name}{" "}{educatorData?.account?.last_name}
                    </Typography>
                    <Rating
                        sx={{...classDetailsSx.rating, display: SHOW_RATINGS ? "block" : "none"}}
                        name="star-rating"
                        value={5}
                        precision={0.5}
                        readOnly
                    />
                    </Box>
                </Box>
                </Grid>
            </Grid>
            <Grid container sx={{...classDetailsSx.scheduleContainer, border: `4px solid ${theme.palette.primary.main}`}}>
                <Grid xs={12} md={6} lg={6} xl={6}>
                <FlexBox mb={2}>
                    <ValueText sx={classDetailsSx.underlineValueText}>Class Schedule</ValueText>
                </FlexBox>
                <Box display={'flex'} flexDirection={'column'}>
                    {formatTimes.map((time, index) => (
                    <HeadingText key={index}>{time}</HeadingText>
                    ))}
                </Box>
                </Grid>
                <Grid display={'flex'} flexDirection={'column'} gap={2} xs={12} md={6} lg={6} xl={6}>
                <FlexBox>
                    <HeadingText>Duration:</HeadingText>
                    {/* eslint-disable-next-line eqeqeq */}
                    <ValueText>{duration}{" "}{duration == 1 ? "Week" : "Weeks"}</ValueText>
                </FlexBox>
                <FlexBox>
                    <HeadingText>First Day of Class:</HeadingText>
                    <ValueText>{firstClass?.month}/{firstClass?.weekday}/{firstClass?.year}</ValueText>
                </FlexBox>
                <FlexBox>
                    <HeadingText>Last Day of Class:</HeadingText>
                    <ValueText>{lastClass?.month}/{lastClass?.weekday}/{lastClass?.year}</ValueText>
                </FlexBox>
                <FlexBox>
                    <HeadingText>Cohort:</HeadingText>
                    <ValueText>{cohort}</ValueText>
                </FlexBox>
                </Grid>
            </Grid>
            </Box>
        )}
        </Box>
    );
};
